<template>
  <div>
    <!-- 数量价格运费修改  -->
    <el-dialog :title="$t('message.quantityPriceFreightModification')" :close-on-click-modal="false"
      :visible.sync="$parent.quantityPriceFreightModificationDialogVisible" width="420px" :before-close="handleClose">
      <!-- 总体 -->
      <div class="content">
        <!-- 修改后数量.元 -->
        <div class="row">
          <div class="label">{{ $t("message.editNumber") }}</div>
          <div class="value">
            <el-input v-model="itemsData.pre_num" type="number"></el-input>
          </div>
        </div>
        <!-- 修改后单价.元 -->
        <div class="row">
          <div class="label">{{ $t("message.editPrice") }}.元</div>
          <div class="value">
            <el-input v-model="itemsData.pre_price" type="number"></el-input>
          </div>
        </div>
        <!-- 修改后运费.元 -->
        <div class="row">
          <div class="label">{{ $t("message.editFreight") }}.元</div>
          <div class="value">
            <el-input v-model="itemsData.pre_freight" type="number"></el-input>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--提交修改  -->
        <el-button type="primary" @click="updatePreData">{{
          $t("message.commitChanges")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: { itemsData: { type: Object } },
  data() {
    return {};
  },
  created() {
    console.log(this.itemsData);
  },
  methods: {
    handleClose() {
      this.$confirm(this.$t("message.confirmTheShutDown"))
        .then((_) => {
          this.$parent.quantityPriceFreightModificationDialogVisible = false;
        })
        .catch((_) => { });
    },
    //修改后数据编辑
    updatePreData() {
      let datas = {
        problem_goods_id: this.itemsData.problem_goods_id,
        pre_num: this.itemsData.pre_num,
        pre_price: this.itemsData.pre_price,
        pre_freight: this.itemsData.pre_freight,
      };
      this.$api.problemApi.updatePreData(datas).then((res) => {
        this.$message.success(res.msg);
        this.$parent.problemList();
        this.$parent.quantityPriceFreightModificationDialogVisible = false;
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  padding: 0 24px;

  .row {
    display: flex;
    margin-bottom: 12px;

    &:nth-last-child(1) {
      margin: 0;
    }

    .label {
      line-height: 40px;
      flex: 1;
    }

    .value {
      flex: 1;
    }
  }
}
</style>